import * as React from 'react'

import { Box, Section, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import { trackAddTemplateWeekShiftManagementStart } from 'modules/shift_management/lib/trackEvents'
import shiftConfigurations from 'modules/shift_management/store/api/collections/shiftConfigurations'
import templateWeeks from 'modules/shift_management/store/api/collections/templateWeeks'
import type ShiftTemplate from 'modules/shift_management/store/api/models/ShiftTemplate'

import AddWeek from './AddWeek'
import BlankSlate from './BlankSlate'
import WeekItem from './WeekItem'

interface Props {
  shiftTemplate: ShiftTemplate
}

const WeekSection = ({ shiftTemplate }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const shiftTemplateId = shiftTemplate.attributes.id

  const { loading } = useAsyncData(() => {
    return Promise.all([
      templateWeeks.fetch({
        data: {
          template_id: shiftTemplateId,
        },
      }),
      shiftConfigurations.fetch(),
    ])
  }, [])

  const weekList = () => {
    const activeTemplateWeeks = templateWeeks.active
    if (!activeTemplateWeeks.length) {
      return <BlankSlate />
    }

    return activeTemplateWeeks.map((week) => (
      <WeekItem key={week.attributes.id} week={week} shiftTemplateId={shiftTemplateId} />
    ))
  }

  const title = i18n.t('shift_management.rotating_shifts.schedules.title')

  const description = i18n.t('shift_management.rotating_shifts.schedules.description')

  const onClick = () => {
    if (!isModalOpen) {
      trackAddTemplateWeekShiftManagementStart(shiftTemplateId)
    }

    setIsModalOpen(!isModalOpen)
  }

  return (
    <>
      <Section
        illustration="clock-app"
        title={title}
        description={description}
        action={{
          label: i18n.t('shift_management.rotating_shifts.schedules.add'),
          onClick,
        }}
      >
        <BoxList>
          {loading ? (
            <Box alignItems="center" width="full" padding="s32">
              <Spinner />
            </Box>
          ) : (
            weekList()
          )}
        </BoxList>
      </Section>
      {isModalOpen && (
        <AddWeek shiftTemplateId={shiftTemplateId} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  )
}

export default observer(WeekSection)
